import { Button, ModalActions, ModalContent, ModalTitle } from "@kaltura/ds-react-components";
import { useState } from "react";
import CreatePlaylistForm, { CreatePlaylistFormProps } from "./form/CreatePlaylistForm";
import { translate } from "@kaltura/ds-react-utils";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

export interface CreatePlaylistModalProps extends Pick<CreatePlaylistFormProps, "apiUrl"> {
    /**
     * is the modal currently open
     */
    open: boolean;

    /**
     * cancel button callback
     */
    onCancel: () => void;
}

const formId = "create-playlist-form";
const baseClassName = "kms-ds-create-playlist-modal";

/**
 * Create Playlist Modal content component
 */
export const CreatePlaylistModalContent = (props: CreatePlaylistModalProps) => {
    const { onCancel, apiUrl } = props;

    const [processing, setProcessing] = useState(false);
    const [disableButton, setDisableButton] = useState(true);

    const sendButtonAnalytics = useButtonAnalytics();

    const updateProcessing = (value: boolean) => {
        setProcessing(value);
    };

    const updateDisableButton = (value: boolean) => {
        setDisableButton(value);
    };

    const handleCancel = () => {
        sendButtonAnalytics(
            "Cancel playlist creation - DS",
            ButtonClickAnalyticsType.CLOSE,
            undefined,
            "Addtoplaylists",
            "Modal box - Create playlist"
        );
        onCancel();
    };

    const isButtonDisabled = processing || disableButton;

    return (
        <>
            <ModalTitle className={`${baseClassName}-title`}>{translate("Create playlist")}</ModalTitle>
            <ModalContent className={`${baseClassName}-content`}>
                <CreatePlaylistForm
                    formId={formId}
                    updateProcessing={updateProcessing}
                    updateDisableButton={updateDisableButton}
                    apiUrl={apiUrl}
                />
            </ModalContent>
            <ModalActions className={`${baseClassName}-actions`}>
                <Button
                    onClick={handleCancel}
                    variant={"borderless"}
                    color={"secondary"}
                    className={`${baseClassName}-actions-cancel`}
                >
                    {translate("Cancel")}
                </Button>
                <Button
                    type={"submit"}
                    loading={processing}
                    disabled={isButtonDisabled}
                    className={`${baseClassName}-actions-submit`}
                    form={formId}
                >
                    {translate("Create")}
                </Button>
            </ModalActions>
        </>
    );
};
